import { API_STATUS, AppResponse, AppRequest } from "@types";
import instance from "./axios";
import { AxiosResponse } from "axios";

/**
 * Function to post a GraphQL query with variables.
 * @param {string} query - The GraphQL query string.
 * @param {T} variables - The variables for the GraphQL query.
 * @returns {Promise<AppResponse<P>>} - A promise that resolves to the response data.
 */

const postGraphql = async <T, P>(
  query: string,
  variables: T, // Ensure T has a 'data' property,
  nextToken?: string | null
): Promise<AppResponse<P>> => {
  try {
    const response = await instance.post<
      AppRequest<T>,
      AxiosResponse<AppResponse<P>>
    >("/graphql", {
      query,
      variables: {
        input:
          typeof variables === "string"
            ? variables
            : {
                ...variables,
                data: (variables as unknown as { data: any }).data
                  ? JSON.stringify((variables as unknown as { data: any }).data)
                  : undefined, // Ensure data is stringified
              },
        nextToken: nextToken || null,
      },
    });

    // console.log("Response data:", JSON.stringify(response.data, null, 2));

    if (response.data.errors) {
      throw new Error(JSON.stringify({ errors: response.data.errors }));
    }

    return {
      status: response.status === 200 ? API_STATUS.SUCCESS : API_STATUS.ERROR,
      statusCode: response.status,
      data: response.data.data,
    };
  } catch (error) {
    // console.error("Error in postGraphql:", error);
    const errors =
      error instanceof Error
        ? JSON.parse(error?.message || "{errors: []}").errors
        : [];
    return {
      status: API_STATUS.ERROR,
      statusCode: 500,
      errors,
      message: "submit_error",
    };
  }
};

export default postGraphql;
